
<template>
  <div class="bg-white  rounded border border-gray-200 hover:-translate-y-1 hover:shadow transition-all duration-300">
    <div class="flex flex-col gap-3 p-5 group">
      <img :src="integration.logo" alt="" class="w-12 h-auto rounded-full">
      <h3 class="font-semibold text-base flex items-center gap-2 ">{{ integration.title }} 
   
        <a v-if="integration.link" :href="integration.link || 'https://wppool.dev/formychat/'" target="_blank" class="opacity-0 group-hover:opacity-100 transition-all duration-300">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-box-arrow-up-right" viewBox="0 0 16 16">
        <path fill-rule="evenodd" d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5"/>
        <path fill-rule="evenodd" d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0z"/>
      </svg></a>

</h3>
      <p class="text-sm text-gray-500">{{ integration.description }}</p>
    </div>
    <div class="fm-card-footer" >
      <!-- Upcoming status - show upcoming tag only -->
      <div v-if="isUpcoming" class="fm-toggle">
        <span class="toggle-label border border-gray-200 rounded-full px-3 py-1.5">{{ t('upcoming') }}</span>
      </div>

      <!-- Available status - main logic -->
      <div v-else-if="isAvailable" class="fm-toggle">
        <!-- Installing loading state -->
        <button
          v-if="isInstalling"
          disabled
          class="fm-btn fm-btn-primary loading"
        >
          <span class="inline-block w-4 h-4 align-middle">
            <svg class="animate-spin w-4 h-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
              <circle cx="25" cy="25" r="20" fill="none" stroke="currentColor" stroke-width="5" stroke-linecap="round" stroke-dasharray="31.415, 31.415" transform="rotate(72 25 25)">
                <animateTransform attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="1s" repeatCount="indefinite"/>
              </circle>
            </svg>
          </span>
          {{ t('installing') }}
        </button>

        <!-- Activating loading state -->
        <button
          v-else-if="isActivating"
          disabled
          class="fm-btn fm-btn-secondary loading"
        >
          <span class="inline-block w-4 h-4 align-middle">
            <svg class="animate-spin w-4 h-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
              <circle cx="25" cy="25" r="20" fill="none" stroke="currentColor" stroke-width="5" stroke-linecap="round" stroke-dasharray="31.415, 31.415" transform="rotate(72 25 25)">
                <animateTransform attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="1s" repeatCount="indefinite"/>
              </circle>
            </svg>
          </span>
          {{ t('activating') }}
        </button>

        <!-- If installed and activated, show toggle -->
        <Toggle
          v-else-if="isInstalled && isActivated"
          v-model="integration.enabled"
          :locked="integration.id !== 'google_sheets'"
          @change="$emit('toggle', integration)"
        />

        <!-- API connection status badge (Mailchimp, Google Sheets, etc.) -->
        <span
          v-if="isInstalled && isActivated && isApiIntegration && !isLocked && integration.enabled && integration.connection_status_checked"
          :class="[
            'api-status-badge',
            integration.api_connected ? 'connected' : 'disconnected'
          ]"
        >
          {{ integration.api_connected ? t('connected') : t('not_connected') }}
        </span>

        <!-- If installed but not activated, show activate button -->
        <button
          v-else-if="isInstalled && !isActivated"
          @click="$emit('activate', integration)"
          class="fm-btn fm-btn-secondary"
        >
          {{ t('activate') }}
        </button>

        <!-- If not installed, show install button -->
        <button
          v-else-if="!isInstalled"
          @click="$emit('install', integration)"
          class="fm-btn fm-btn-primary"
        >
          {{ t('install') }}
        </button>
      </div>
      
      <!-- Settings icon: show only when available + installed + activated + enabled -->
      <button
        v-if="isAvailable && isInstalled && isActivated && integration.enabled && !(integration.id === 'mailchimp' && isLocked)"
        @click="$emit('settings', integration)"
        class="fm-settings"
        aria-label="Settings"
      >
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-gear" viewBox="0 0 16 16">
  <path d="M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492M5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0"/>
  <path d="M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 0 0 2.693 1.115l.291-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.873 1.873 0 0 0 1.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 0 0-1.115 2.693l.16.291c.415.764-.42 1.6-1.185 1.184l-.291-.159a1.873 1.873 0 0 0-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 0 0-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.291A1.873 1.873 0 0 0 1.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 0 0 3.06 4.377l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 0 0 2.692-1.115z"/>
</svg>
      </button>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { Toggle } from '@components'
import { useTranslation } from '@composables/useTranslation'

const { t } = useTranslation();

const props = defineProps({
  integration: {
    type: Object,
    required: true
  }
})


defineEmits(['toggle', 'settings', 'install', 'activate'])

// Simple computed properties based on integration properties
const isAvailable = computed(() => props.integration.status === 'available')
const isUpcoming = computed(() => props.integration.status === 'upcoming')
const isApiIntegration = computed(() => props.integration.type === 'api')
const isInstalled = computed(() => {
  // API integrations are always "installed" (no plugin needed)
  if (isApiIntegration.value) return true
  return props.integration.is_plugin_installed
})
const isActivated = computed(() => {
  // API integrations are always "activated" (no plugin needed)
  if (isApiIntegration.value) return true
  return props.integration.is_plugin_active
})
const isInstalling = computed(() => props.integration.installing)
const isActivating = computed(() => props.integration.activating)

const isLocked = computed(() => 1 != formychat_admin_vars.is_premium)
</script>

<style scoped>
.fm-card {
  background: #ffffff;
  border: 1px solid #e6e8ef;
  border-radius: 3px;
  display: flex;
  flex-direction: column;
  min-height: 180px;
  transition: all 0.2s;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
}

.fm-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  border-color: #cbd5e1;
}

.is-upcoming {
  opacity: 0.7;
}

.fm-card-body {
  display: flex;
  gap: 16px;
  padding: 18px;
  flex: 1;
}

.fm-icon {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-weight: 700;
  font-size: 16px;
  flex-shrink: 0;
}

.fm-content {
  flex: 1;
}

.fm-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  margin-bottom: 6px;
  font-size: 16px;
  color: #1f2937;
}

.fm-badge {
  font-size: 11px;
  background: #f2f3f7;
  border: 1px solid #e1e4ef;
  border-radius: 999px;
  padding: 3px 8px;
  color: #6b7280;
  font-weight: 500;
}

.fm-desc {
  margin: 0;
  color: #606776;
  font-size: 13px;
  line-height: 1.4;
}

.fm-card-footer {
  margin-top: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-top: 1px solid #eef1f6;
  height: 60px;
}

.fm-toggle {
  display: flex;
  align-items: center;
  gap: 10px;
}

.toggle-label {
  font-size: 12px;
  color: #555;
  font-weight: 500;
}

/* Switch */
.switch {
  position: relative;
  display: inline-block;
  width: 38px;
  height: 22px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #d1d5db;
  transition: .2s;
  border-radius: 999px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: .2s;
  border-radius: 50%;
}

.switch input:checked + .slider {
  background-color: #5163F1;
}

.switch input:checked + .slider:before {
  transform: translateX(16px);
}

.switch input:disabled + .slider {
  background-color: #e5e7eb;
  cursor: not-allowed;
}

.fm-settings {
  border: none;
  background: #f5f7ff;
  border: 1px solid #e0e6ff;
  color: #4654e1;
  border-radius: 8px;
  padding: 6px 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.fm-settings:hover:not(:disabled) {
  background: #eef2ff;
  border-color: #c7d2fe;
}

.fm-settings:disabled {
  opacity: .4;
  cursor: not-allowed;
}

.fm-btn {
  padding: 6px 12px;
  border-radius: 20px;
  border: 1px solid;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  transition: all 0.2s;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.fm-btn-secondary {
  border-color: #e5e7eb;
  color: #374151;
  background: #f9fafb;
}

.fm-btn-secondary:hover {
  background: #f3f4f6;
  border-color: #d1d5db;
}

.fm-btn-primary {
  background: #5163f1;
  border-color: #5163f1;
  color: white;
}

.fm-btn-primary:hover {
  background: #4338ca;
  border-color: #4338ca;
}

.fm-btn:disabled,
.fm-btn.loading {
  opacity: 0.7;
  cursor: not-allowed;
}

.fm-btn.loading:hover {
  border-color: inherit;
}

.api-status-badge {
  font-size: 10px;
  padding: 2px 6px;
  border-radius: 8px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.api-status-badge.connected {
  background: #d1fae5;
  color: #065f46;
  border: 1px solid #6ee7b7;
}

.api-status-badge.disconnected {
  background: #fee2e2;
  color: #991b1b;
  border: 1px solid #fca5a5;
}
</style>